module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"group":[{"fieldValue":"intro","totalCount":1}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags.json
// module id = 351
// module chunks = 55702396619907